import { gql } from '@apollo/client'

export const COMPANY_COLD_AVAILABILITY_FORMULA_GROUPS = gql`
  query CompanyColdAvailabilityFormulaGroups {
    companyColdAvailabilityFormulaGroups {
      name
      id
      info
    }
  }
`
